"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var BlCheckbox_1 = __importDefault(require("../BlCheckbox"));
var react_i18next_1 = require("react-i18next");
var lodash_1 = __importDefault(require("lodash"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var BlCheckboxGroup = function (_a) {
    var onChange = _a.onChange, options = _a.options, checked = _a.checked, isRadioBox = _a.isRadioBox, disabled = _a.disabled;
    var t = react_i18next_1.useTranslation('common').t;
    var opts = react_1.useMemo(function () {
        return options.map(function (o) {
            return __assign(__assign({}, o), { checked: checked.includes(o.text), label: t("FIELD_OPTIONS." + o.label) });
        });
    }, [options]);
    return (react_1.default.createElement("ul", { className: styles_module_scss_1.default.checkbox_group }, opts.map(function (option, index) {
        return (react_1.default.createElement("li", { className: styles_module_scss_1.default.checkbox, key: index },
            react_1.default.createElement(BlCheckbox_1.default, __assign({}, option, { onChange: function (event, _a) {
                    var _b = _a.checked, checked = _b === void 0 ? false : _b;
                    if (!lodash_1.default.isUndefined(isRadioBox) && isRadioBox) {
                        opts.map(function (item) { return (item.checked = false); });
                    }
                    opts[index].checked = checked;
                    onChange(opts.reduce(function (total, current) {
                        return current.checked
                            ? __spreadArray(__spreadArray([], total), [current.text]) : total;
                    }, []));
                }, disabled: disabled }))));
    })));
};
exports.default = BlCheckboxGroup;
